import { parseISO } from "date-fns";
import type { InvestorWithFieldValues } from "../../../../api/types/fundStructureTypes";
import type { SearchFilterDefinition, TableFilterDefinition } from "../../../common/filters/filterTypes";

export const staticFilterDefinitions: TableFilterDefinition<InvestorWithFieldValues>[] = [
  {
    type: "multi_select",
    id: "investorEntityType",
    name: "Entity Type",
    getFieldValue: (row) => row.investorEntityType,
  },
  {
    type: "multi_select",
    id: "funds",
    name: "Fund",
    getFieldValue: (row) => row.funds.map((fund) => fund.fundName),
  },
  {
    type: "multi_select",
    id: "contacts",
    name: "Contact",
    getFieldValue: (row) => row.contacts.map((contact) => contact.name),
  },
  {
    type: "date",
    id: "createdAt",
    name: "Created at",
    getFieldValue: (row) => parseISO(row.createdAt),
  },
  {
    type: "date",
    id: "updateAt",
    name: "Modified at",
    getFieldValue: (row) => parseISO(row.updateAt),
  },
];

export const searchDefinition: SearchFilterDefinition<InvestorWithFieldValues> = {
  getFieldValues: (row) => [
    row.title,
    ...row.funds.map((fund) => fund.fundName),
    ...row.contacts.map((contact) => contact.name),
    row.id,
  ],
};
